<template>
  <section class="SectionIllustratedList" :class="background">
    <Wrap class="lg">
      <div v-if="title" class="heading">
        <h2>
          {{ title }}
        </h2>
      </div>

      <div class="videoContainer">
        <Video
          v-if="videoSrc"
          :src="videoSrc"
          :title="title" />
      </div>

      <div v-for="item in items" :key="item.title" class="item">
        <Row>
          <Column :md="6">
            <Pic :alt="item.alt" :formats="['webp']" :src="item.src" />
          </Column>
          <Column class="body" :md="6">
            <Wrap>
              <h3 class="title">
                {{ item.title }}
              </h3>
              <p v-if="item.text">
                {{ item.text }}
              </p>
              <Markdown v-else-if="item.content" :markdown="item.content" />
            </Wrap>
          </Column>
        </Row>
      </div>
    </Wrap>
  </section>
</template>

<script>
import Video from 'views/components/Video'
const Markdown = () => import(/* webpackChunkName: 'showdown' */ 'views/components/Markdown')

export default {
  components: { Markdown, Video },
  props: {
    background: String,
    items: Array,
    title: String,
    videoSrc: String,
  },
}
</script>

<style lang="scss">
.SectionIllustratedList {
  background-color: $grey-lightest;
  color: $black-true;
  padding: 2rem 0;
  @include md {
    padding: 8rem 0;
  }

  .videoContainer {
    .Video {
      > img, .image > .thumbnail, .image > .thumbnail > img {
        display: block;
        height: 100%;
        margin-bottom: 2rem;
        object-fit: cover;
        width: 100%;
      }
    }
  }

  .heading {
    padding-bottom: 2rem;
    @include md {
      padding-bottom: 8rem;
    }
  }

  .item {
    background: $white;
    margin: 0 auto 2rem;
    @include md {
      margin-bottom: 4rem;
    }

    .Row {
      align-items: center;

      img {
        object-fit: cover;
        width: 100%;
      }

      .body {
        padding: 3rem 1rem;
        @include md {
          min-height: 20rem;
        }

        > .Wrap {
          max-width: 40rem;

          h3.title {
            font-size: $h5;
            font-weight: $semibold;
            margin-bottom: 3rem;
          }
        }

        p {
          opacity: 0.7;
        }
      }
    }
  }
}
</style>
